import { render, staticRenderFns } from "./proPerty.vue?vue&type=template&id=659cc135&scoped=true"
import script from "./proPerty.vue?vue&type=script&lang=js"
export * from "./proPerty.vue?vue&type=script&lang=js"
import style0 from "./proPerty.vue?vue&type=style&index=0&id=659cc135&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659cc135",
  null
  
)

export default component.exports